import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d7f01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-2xl font-bold flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Download ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Created at:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Amount:", -1))
const _hoisted_6 = { class: "base-cost" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant:", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Code:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Quantity:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Cost:", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SKU:", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tracking:", -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_OrderImagePreview = _resolveComponent("OrderImagePreview")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, { backPageTitle: `Back` }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" InvoiceID: " + _toDisplayString(_ctx.invoice._id) + " ", 1),
        _withDirectives(_createVNode(_component_el_button, {
          type: "text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExportInvoice(_ctx.invoice)))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 512), [
          [_directive_loading, _ctx.isLoading]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.invoice.createdDate)), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatterDollars(_ctx.invoice.sellerAmount)), 1)
      ]),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.state.orders,
        "element-loading-text": "Loading...",
        lazy: true,
        style: {"width":"100%"},
        stripe: "",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items.filter(
              i => i.sku !== 'Tip'
            ), (item, iItem) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  class: "py-3 px-5",
                  gutter: 20,
                  key: iItem
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "pl-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OrderImagePreview, {
                          item: item,
                          disableEdit: true
                        }, null, 8, ["item"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, [
                              (item.productId)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                    _createVNode(_component_router_link, {
                                      to: {
                        name: 's.product-detail',
                        params: { id: item.productId },
                      },
                                      class: "text-primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.itemName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.itemName), 1))
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.variantTitle)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                      _hoisted_11,
                                      _createTextVNode(" " + _toDisplayString(item.variantTitle), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.catalogCode)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                      _hoisted_13,
                                      _createTextVNode(" " + _toDisplayString(item.catalogCode), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", null, [
                                  _hoisted_14,
                                  _createTextVNode(" " + _toDisplayString(item.quantity), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_15,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(item.sellerAmount)), 1)
                                ]),
                                (item.sku && item.sku != 'SKU')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                      _hoisted_17,
                                      _createTextVNode(" " + _toDisplayString(item.sku), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.trackingNumber)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                      _hoisted_19,
                                      _createTextVNode(" " + _toDisplayString(item.trackingNumber), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.carrier)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                      _hoisted_21,
                                      _createTextVNode(" " + _toDisplayString(item.carrier), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              props: column.dataIndex
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Order')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
                name: 'seller.orders.detail',
                params: { id: scope.row._id },
              },
                      class: "text-blue-600"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (column.title === 'Amount')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 1))
                    : (column.title === 'Status')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                          _createVNode(_component_el_tag, {
                            type: _ctx.getOrderStatusColor(scope.row.status),
                            size: "small",
                            title: scope.row.status
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.status)), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "title"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["label", "props"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.state.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"])
    ]),
    _: 1
  }, 16))
}